import * as React from 'react';
import { createStyles } from "@mantine/core";

interface IColorCellProps {
    value: string;
}

const useStyles = createStyles((theme, { color }: { color: string }) => {
    return {
        container: {
            display: 'flex',
            alignItems: 'center',
        },
        text: {

        },
        color: {
            backgroundColor: color,
            display: 'inline-block',
            width: 20,
            height: 20,
            borderRadius: '50%',
            marginRight: '1rem'
        }
    }
})

const ColorCell = ({
    value
}: IColorCellProps) => {
    const { classes } = useStyles({ color: value });
    return (
        <div className={classes.container}>
            <span className={classes.color}/>
            <span className={classes.text}>
                {value}
            </span>
        </div>
    )
};

export default ColorCell;
